import * as React from 'react';
import { connect } from 'react-redux';

import BrandProfileEditFormContainer from './BrandProfileEditFormContainer';
import ProfileApprovalStatus from 'modules/brands/components/profile-approval-status/ProfileApprovalStatus';

import { fetchBrandProfile, saveBrandProfile } from '../reducers/brandProfile';

import { navigate } from 'libs/router';

import type { BrandProfile, BrandProfileForm } from 'types';

type OwnProps = {
  profileId: number,
  agencyId?: number,
  organizationType?: string,
  isSpecialtyAdminPage?: boolean
};

type StateProps = {
  brandProfile: BrandProfile,
  currentOrganizationId: number
};

type DispatchProps = {
  dispatchSaveBrandProfile: (b: number, a: BrandProfileForm) => Promise<any>,
  dispatchFetchBrandProfile: (a: number) => Promise<any>
};

type Props = OwnProps & StateProps & DispatchProps;

class BrandEditProfile extends React.Component<Props> {
  componentDidMount() {
    const { dispatchFetchBrandProfile, profileId } = this.props;

    dispatchFetchBrandProfile(profileId);
  }

  handleSave = (profileDetails: BrandProfileForm) => {
    const { brandProfile, dispatchSaveBrandProfile } = this.props;

    return dispatchSaveBrandProfile(brandProfile.id, profileDetails);
  };

  handleAfterSave = (profile: BrandProfile) => {
    const { agencyId, currentOrganizationId, isSpecialtyAdminPage } = this.props;

    let redirectLink = agencyId
      ? `/agency/${agencyId}/settings/profile`
      : `/organizations/${currentOrganizationId}/brand/settings`;

    if (isSpecialtyAdminPage) {
      redirectLink = agencyId
        ? `/admin/agency/${agencyId}/settings/profile`
        : `/admin/brand/profiles/${profile.id}`;
    }

    navigate.to(redirectLink);
  };

  render() {
    const { brandProfile, currentOrganizationId, organizationType } = this.props;

    if (!brandProfile.id) {
      return null;
    }

    return (
      <section className="brand-profile layout-container-narrow">
        <ProfileApprovalStatus
          profile={brandProfile}
          profileType="brand"
        />
        <BrandProfileEditFormContainer
          key={`${currentOrganizationId} - ${brandProfile?.id}`}
          onSave={this.handleSave}
          onAfterSave={this.handleAfterSave}
          organizationType={organizationType}
        />
      </section>
    );
  }
}

const mapStateToProps = ({ organizations, brandProfile }): StateProps => ({
  brandProfile: brandProfile.profile,
  currentOrganizationId: organizations.currentOrganizationId
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchSaveBrandProfile: (profileId, profileDetails) => dispatch(saveBrandProfile(profileId, profileDetails)),
  dispatchFetchBrandProfile: (profileId) => dispatch(fetchBrandProfile(profileId, true, true))
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandEditProfile);
